module.exports = __webpack_public_path__ + "static/media/infraestructura.32e39564.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vector/infraestructura.svg
// module id = 362
// module chunks = 0